import { ResourcesCounts } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";

function getPlanzoneResourcesCounts(httpClient: HttpClient) {
  return () =>
    httpClient
      .sendHttpRequest<ResourcesCounts>({
        endpoint: "/resources/counts",
        method: HttpMethods.GET,
      })
      .then(({ human, material, virtual, inactive }) => ({
        human,
        material,
        virtual,
        inactive,
      }))
      .catch((e) => Promise.reject({ ...e, message: e.detail || "" }));
}

export { getPlanzoneResourcesCounts };
